
import {useContext, useEffect, useState} from "react";

import {
    ApiFilled,
    AppstoreOutlined,
    ContainerOutlined,
    DesktopOutlined, HomeFilled,
    MailOutlined,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    PieChartOutlined, SettingFilled, UserOutlined,
} from '@ant-design/icons';
import {Avatar, Button, Menu} from 'antd';
import {appContext} from "../state";
import {useLocation} from "react-router-dom";


function NavigationBarVertical(props) {

    const [collapsed, setCollapsed] = useState(true);
    const {appStateContextValue} = useContext(appContext);
    const [appState, setAppState] = appStateContextValue
    const location = useLocation();
    const { hash, pathname, search } = location;
    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
    };


    const items = [
        { key: '/', icon: <HomeFilled />, label: 'Home' },
        //{ key: 'MOCK_API', icon: <ApiFilled />, label: 'API Mocks' },
        { key: '/settings', icon: <SettingFilled />, label: 'Settings' },
    ];

    useEffect(() => {
       // console.log('APP_STATE',appState)
    }, []);

    function onClick (e) {
        //console.log(e)
       // props.onKeyUp ? props.onKeyUp(e) : false
        props.onNavBarTabClick(e)
    }

    function onAvatarClick () {
        props.onNavBarTabClick({key:'PROFILE'})
    }

    return (
        <div style={{width: 72}} className="navigation-bar-vertical">
            <Menu
                selectedKeys={[pathname]}
                onClick={onClick}
                style={{'background':'#282A35',width:'100%'}}
                defaultSelectedKeys={['1']}
                defaultOpenKeys={['sub1']}
                mode="inline"
                theme="dark"
                inlineCollapsed={collapsed}
                items={items}
            />
            {appState.user.image ? <div onClick={onAvatarClick} className="avatar"><Avatar style={{ backgroundColor: getComputedStyle(document.body).getPropertyValue('--primary-color') }} size={32} icon={<UserOutlined />} /></div> : false}
            {/*<Button type="primary" onClick={toggleCollapsed} className="collapse-button">
                {collapsed ? <MenuUnfoldOutlined/> : <MenuFoldOutlined/>}
            </Button>*/}
        </div>
    );
}

export default NavigationBarVertical;
